
    import { animate, stagger, splitText } from 'animejs';
    import { initNavPill } from './src/lib/navPill.js';

    /* Size the scrolled nav island to its real content so the CTA
       can't hang outside the plate (see src/lib/navPill.js). */
    initNavPill(document.querySelector('.about-nav'));


    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    function blurStagger (el, { onLoad = false } = {}) {
      if (!el) return;
      // Prime: hide while we wrap, lock per-char resting state, then reveal.
      el.style.opacity = '0';
      const splitter = splitText(el, {
        chars: { wrap: true, class: 'anime-split-char' },
        accessible: true,
      });
      const chars = splitter.chars;
      for (const c of chars) {
        c.style.display = 'inline-block';
        c.style.opacity = '0';
        c.style.filter = 'blur(12px)';
        c.style.willChange = 'filter, opacity';
      }
      el.style.opacity = '1';

      if (reduced) {
        for (const c of chars) { c.style.opacity = '1'; c.style.filter = 'none'; }
        return;
      }

      animate(chars, {
        opacity: [0, 1],
        filter: ['blur(12px)', 'blur(0px)'],
        duration: 1500,
        ease: 'outExpo',
        delay: stagger(28, { start: onLoad ? 180 : 0 }),
      });
    }

    // Hero — fire as soon as the module evaluates.
    blurStagger(document.querySelector('.about-hero__headline'), { onLoad: true });

    // Narrative heading — gate on viewport entry so the reveal lands as
    // the section comes into view.
    const narrative = document.querySelector('.about-narrative__heading');
    if (narrative) {
      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          blurStagger(e.target);
          io.unobserve(e.target);
        }
      }, { threshold: 0.4, rootMargin: '0px 0px -10% 0px' });
      io.observe(narrative);
    }


    /* ── Team stat numerals — count up from 0 to data-to once the
       card enters the viewport. Reads data-to + optional data-suffix
       (e.g. "+" or "x") and animates the displayed text via anime.js. */
    (function () {
      const nums = Array.from(document.querySelectorAll('[data-stat-num]'));
      if (!nums.length) return;

      function settle (el) {
        el.textContent = (el.dataset.to || '0') + (el.dataset.suffix || '');
      }
      if (reduced) {
        nums.forEach(settle);
        return;
      }

      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          const el = e.target;
          const target = parseInt(el.dataset.to, 10) || 0;
          const suffix = el.dataset.suffix || '';
          const state = { v: 0 };
          animate(state, {
            v: target,
            duration: 1400,
            ease: 'outExpo',
            onUpdate: () => { el.textContent = Math.round(state.v) + suffix; },
            onComplete: () => { el.textContent = target + suffix; },
          });
          io.unobserve(el);
        }
      }, { threshold: 0.5, rootMargin: '0px 0px -10% 0px' });

      nums.forEach((el) => io.observe(el));
    })();

    /* ── Our Values — fade-in reveal.
       Each card starts at opacity:0. When the grid enters the
       viewport, anime.js fades them in with a 120ms stagger so they
       arrive one by one. */
    (function () {
      const grid = document.querySelector('[data-values-grid]');
      if (!grid) return;
      const cards = grid.querySelectorAll('[data-values-card]');
      if (!cards.length) return;

      if (reduced) {
        for (const c of cards) c.style.opacity = '1';
        return;
      }

      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          animate(cards, {
            opacity: [0, 1],
            duration: 1400,
            ease: 'outSine',
            delay: stagger(100),
          });
          io.unobserve(e.target);
        }
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      io.observe(grid);
    })();
  